import Forms from './Forms.css';
import Booking from './Booking/Booking.css';
import Field from './Field/Field.css';

export default {
	Forms,
	Booking,
	Field
};
